// Shared register/cancel button state for an open session, used by both the list card
// (OpenSessionCard) and the detail popup (OpenSessionDetailModal) so the two can never
// disagree about whether a session can be joined.
//
// Returns semantics only — the translation key and a variant name. Each caller resolves the
// key through $t and maps the variant onto its own sizing/classes, since the card renders a
// compact chip and the modal a full-width button.

export const CTA_VARIANT = {
  DISABLED: 'disabled',
  REGISTERED: 'registered',
  DEFAULT: 'default'
};

export function openSessionCtaState(session, pending) {
  const cancelled = session?.status === 'Cancelled';
  const registered = !!session?.isRegistered;
  const full = !!session?.isFull && !registered;

  let labelKey = 'Views.OpenSessions.ctaRegister';
  if (cancelled) labelKey = 'Views.OpenSessions.ctaCancelled';
  else if (registered) labelKey = 'Views.OpenSessions.ctaCancelRegistration';
  else if (full) labelKey = 'Views.OpenSessions.ctaFull';

  let variant = CTA_VARIANT.DEFAULT;
  if (cancelled || full) variant = CTA_VARIANT.DISABLED;
  else if (registered) variant = CTA_VARIANT.REGISTERED;

  return {
    disabled: !!pending || cancelled || full,
    labelKey,
    variant,
    // The event name the caller should emit when the button is pressed.
    action: registered ? 'unregister' : 'register'
  };
}
